export default "__VITE_ASSET__757dce78__"